export default __webpack_public_path__ + "static/media/activeArrowRightLight.f1193d68.svg";